import React from 'react'

interface MailchimpFormProps {
  onSubmitted: () => void
}

export const MailchimpForm = ({
  onSubmitted,
}: MailchimpFormProps) => {
  const handleSubmit = () => {
    window.setTimeout(() => {
      onSubmitted()
    }, 500)
  }

  return (
    <>
      <iframe
        title="Mailchimp subscription response"
        name="mailchimp-response"
        style={{
          display: 'none',
        }}
      />

      <form
        action={
          'https://ovaflopick.us13.list-manage.com/subscribe/post' +
          '?u=92ed3b0ca287678392c6b6384' +
          '&id=7bea36bd2a' +
          '&f_id=004dc3e1f0'
        }
        method="post"
        target="mailchimp-response"
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          fontFamily: 'Arial, Helvetica, sans-serif',
        }}
      >
        <label
          htmlFor="mailchimp-first-name"
          style={{
            fontSize: '11px',
            letterSpacing: '2px',
            textTransform: 'uppercase',
          }}
        >
          First Name
        </label>

        <input
          id="mailchimp-first-name"
          name="FNAME"
          type="text"
          required
          autoComplete="given-name"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '17px 0',
            backgroundColor: 'transparent',
            color: '#f3efe7',
            border: 0,
            borderBottom: '1px solid #f3efe7',
            borderRadius: 0,
            outline: 'none',
            fontSize: '17px',
          }}
        />

        <label
          htmlFor="mailchimp-email"
          style={{
            marginTop: '14px',
            fontSize: '11px',
            letterSpacing: '2px',
            textTransform: 'uppercase',
          }}
        >
          Email
        </label>

        <input
          id="mailchimp-email"
          name="EMAIL"
          type="email"
          required
          autoComplete="email"
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '17px 0',
            backgroundColor: 'transparent',
            color: '#f3efe7',
            border: 0,
            borderBottom: '1px solid #f3efe7',
            borderRadius: 0,
            outline: 'none',
            fontSize: '17px',
          }}
        />

        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: '-5000px',
          }}
        >
          <input
            type="text"
            name="b_92ed3b0ca287678392c6b6384_7bea36bd2a"
            tabIndex={-1}
            defaultValue=""
          />
        </div>

        <button
          type="submit"
          style={{
            width: '100%',
            minHeight: '58px',
            marginTop: '24px',
            padding: '0 24px',
            border: '1px solid #f3efe7',
            backgroundColor: '#f3efe7',
            color: '#171714',
            fontSize: '12px',
            fontWeight: 700,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            cursor: 'pointer',
          }}
        >
          Join Made to Wear
        </button>
      </form>
    </>
  )
}
